import Phaser from 'phaser';
import { QuickDrawServiceAPI } from '../services/QuickDrawServiceAPI';
import { addAudio, addTextureBase64, loadAssets } from '../utils/AssetLoader';

const WinningNumberSrc = require('../assets/default/audio/Bright Bonus Win.mp3');
const RollingDices = require('../assets/default/audio/RollingDices.mp3');
export class PreloadingScene extends Phaser.Scene {
  constructor() {
    super('PreloadingScene');
  }

  preloadAudio() {
    addAudio('Bright_Bonus_Win', WinningNumberSrc.default);
    addAudio('RollingDices', RollingDices.default);
  }
  preload() {
    this.preloadAudio();
    this.preloadImages();
    loadAssets(this, this.onLoadAssetsStart, this.onLoadAssetsComplete);
  }

  preloadImages() {
    // DO NOT remove - the base64 cache doesn't load if image loader is not initialized
    // this.load.image('_', '_');

    this.load.image('background', require('../assets/default/background.png').default);
    addTextureBase64('topbar', require('../assets/default/Top_Bar.png').default);
    addTextureBase64('drawingid', require('../assets/default/drawingid_button.png').default);
    addTextureBase64('play', require('../assets/default/Play.png').default);
    addTextureBase64('replay', require('../assets/default/replay.png').default);
    addTextureBase64('pause', require('../assets/default/Pause.png').default);
    addTextureBase64('edit', require('../assets/default/edit.png').default);
    addTextureBase64('done', require('../assets/default/done.png').default);
    addTextureBase64('next_draw', require('../assets/default/next_draw.png').default);
    addTextureBase64('money_roll_logo', require('../assets/default/money-roll-logo.png').default);
    addTextureBase64('money_roll_logo_superbonus', require('../assets/default/money-roll-superbonus-logo.png').default);
    addTextureBase64('winning_numbers', require('../assets/default/winning-numbers.png').default);
    addTextureBase64('super_bonus', require('../assets/default/super-bonus.png').default);
    addTextureBase64('dice1', require('../assets/default/Dice/dice-01.png').default);
    addTextureBase64('dice2', require('../assets/default/Dice/dice-02.png').default);
    addTextureBase64('dice3', require('../assets/default/Dice/dice-03.png').default);
    addTextureBase64('dice4', require('../assets/default/Dice/dice-04.png').default);
    addTextureBase64('dice5', require('../assets/default/Dice/dice-05.png').default);
    addTextureBase64('dice6', require('../assets/default/Dice/dice-06.png').default);
    addTextureBase64('multiplier_shadow', require('../assets/default/multipliers-shadow.png').default);

    for (let i = 1; i < 6; i++) {
      const key = `${i}-multiplier`;
      addTextureBase64(key, require(`../assets/default/multipliers/bonus-dice-${i}-x.png`).default);
      addTextureBase64(`${key}-highlight`, require(`../assets/default/multipliers/bonus-dice-${i}-x-win.png`).default);
    }

    for (let i = 0; i < 6; i++) {
      addTextureBase64('countdown_' + i, require('../assets/default/CountDown/Countdown_' + i + '.png').default);
    }
  }

  private onLoadAssetsStart = () => {
    const screenWidth = 750;
    const screenHeight = 1334;
    this.add
      .text(screenWidth / 2, screenHeight / 2, 'Loading game...', {
        font: '40px Jost-SemiBold',
        color: '#000'
      })
      .setOrigin(0.5);
  };

  private onLoadAssetsComplete = () => {
    window._po_gm.ready();
    //Uncomment this to start the game locally
    // window.po_gm.start({
    //   gameId: 1231,
    //   drawId: '190',
    //   drawResult: [1, 4, 2, 6, 3, 5],
    //   availableDraws: {
    //     '191': {
    //       drawResult: [1, 6, 3, 4, 2, 3]
    //     },
    //     '192': {
    //       drawResult: [6, 4, 1, 2, 5, 3]
    //     },
    //     '193': {
    //       drawResult: [3, 5, 4, 2, 6, 1]
    //     }
    //   }
    // });
    if (!window._po_gm.config) {
      this.makeDefaultConfigAndStartGame();
    }
  };

  create() {
    if (!!window._po_gm.config && !!window._po_gm.config.errorMsg) {
      this.scene.start('ErrorScene');
    }
  }

  makeDefaultConfigAndStartGame() {
    const gameId = this.getGameId();
    if (!gameId) return;
    QuickDrawServiceAPI.getLatestQuickDrawWithWinnerResultByGame(gameId).then(response => {
      const config = {
        gameId,
        drawId: response.drawId,
        drawResult: response.drawResult,
        availableDraws: {}
      };
      window.po_gm.start(config);
    });
  }

  getGameId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const gameId = urlParams.get('gameId');
    if (!!gameId) {
      return parseInt(gameId ? gameId : '0', 10);
    } else {
      return null;
    }
  }
}
